<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<style>
/* 全局布局辅助 */
.el-row {
  margin-bottom: 20px;
}
.el-row:last-child {
  margin-bottom: 0;
}
.el-col {
  border-radius: var(--radius-sm);
}
.grid-content {
  border-radius: var(--radius-sm);
  min-height: 36px;
}
</style>

<script>
export default {
  name: 'App',
  mounted() {
    navigator.sendBeacon('/api/session/keep');
  }
}
</script>
